import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'wrapOnCommas' })
export class WrapOnCommasPipe implements PipeTransform
{
  constructor(private s: DomSanitizer) { }
  transform(v: string): SafeHtml
  {
    return this.s.bypassSecurityTrustHtml(v?.replaceAll(',', ',<wbr>') ?? '');
  }
}
